var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"like-btn"},[_c('button',{staticClass:"watchlist-btn",attrs:{"type":"button"},on:{"click":_vm.toggleWatchlistState}},[_c('img',{attrs:{"src":_vm.ico,"alt":"watchlist"}}),_vm._v(" "),(!_vm.showLoader)?_c('p',{staticClass:"like-tag",style:({
        color: _vm.ico !== _vm.like ? '#5568F1' : _vm.labelColor
      })},[_vm._v("\n      "+_vm._s(_vm.likeCount)+"\n    ")]):_c('Loader')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39eb119e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Templates/likeBtn.vue
// module id = 425
// module chunks = 22